import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import theme from "styled-theming";
import ScaleText from "react-scale-text";

const burstBackgroundColor = theme.variants("mode", "variant", {
  neutral: {
    light: "#808080",
    dark: "#808080",
  },
  secondary: {
    light: (props) => props.theme.colors.secondary.main.color,
    dark: (props) => props.theme.colors.secondary.main.color,
  },
  primary: {
    light: (props) => props.theme.colors.primary.main.color,
    dark: (props) => props.theme.colors.primary.main.color,
  },
  "primary.dark": {
    light: (props) => props.theme.colors.primary.dark.color,
    dark: (props) => props.theme.colors.primary.dark.color,
  },
});

const burstTextColor = theme.variants("mode", "variant", {
  neutral: {
    light: "white",
    dark: "white",
  },
  secondary: {
    light: (props) => props.theme.colors.secondary.main.contrastColor,
    dark: (props) => props.theme.colors.secondary.main.contrastColor,
  },
  primary: {
    light: (props) => props.theme.colors.primary.main.contrastColor,
    dark: (props) => props.theme.colors.primary.main.contrastColor,
  },
  "primary.dark": {
    light: (props) => props.theme.colors.primary.dark.contrastColor,
    dark: (props) => props.theme.colors.primary.dark.contrastColor,
  },
});

const PointBurstDefault = styled.div`
  position: absolute;
  background-color: ${burstBackgroundColor};
  color: ${burstTextColor};
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  font-size: 36px;
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: ${burstTextColor} !important;
  }
`;

PointBurstDefault.defaultProps = {
  variant: "primary",
};

const PointBurst30 = PointBurstDefault.extend`
  transform: rotate(30deg);
`;

const PointBurst60 = PointBurstDefault.extend`
  transform: rotate(60deg);
`;

class PointBurst extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { content, variant, size } = this.props;

    return (
      <React.Fragment>
        <PointBurst30 variant={variant} size={size} />
        <PointBurst60 variant={variant} size={size} />
        <PointBurstDefault variant={variant} size={size}>
          {content}
        </PointBurstDefault>
      </React.Fragment>
    );
  }
}

PointBurst.propTypes = {
  content: PropTypes.object.isRequired,
  size: PropTypes.optionalNumber,
};

PointBurst.defaultProps = {
  variant: "primary",
  size: 80,
};

export default PointBurst;
